// cd: keep --header-bottom-position-desktop fresh for sticky announcement + mega menu
(function () {
  function update() {
    var w = document.querySelector('.header-wrapper');
    if (!w) return;
    var v = Math.floor(w.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--header-bottom-position-desktop', v + 'px');
  }
  update();
  window.addEventListener('load', update);
  window.addEventListener('resize', update);
})();
